import { getFilenameFromResponse, downloadFile } from '@helpers/utils';
import { ResponseErrorDto } from '@interfaces/models';
import { useMutation } from '@tanstack/react-query';
import { createFilePublicLink } from '@api/files';
import { useTranslation } from 'react-i18next';
import { toast } from '@ui/components';

export const useGetFile = ({ onSuccess }: { onSuccess?: () => void }) => {
  const { t } = useTranslation();

  const { mutate: handleGetFile, isPending: isGettingFilePublicLink } = useMutation({
    mutationFn: ({ objectName, bucketName }: { objectName: string; bucketName: string }) =>
      createFilePublicLink(objectName, bucketName),
    onSuccess: (data) => {
      getFileFromBucketMutation(data);
    },
    onError: ({ error }: { error: ResponseErrorDto }) => {
      toast.success(t(`API_ERRORS.${error.errorCode}`));
    },
  });

  const { mutate: getFileFromBucketMutation, isPending: isGettingFileFromBucket } = useMutation({
    mutationFn: async (fileLink: string) => {
      const response = await fetch(fileLink);
      const blob = await response.blob();
      const filename = getFilenameFromResponse(response);

      return { blob, filename };
    },
    onSuccess: ({ blob, filename }) => {
      downloadFile(blob, filename);
      onSuccess?.();
    },
    onError: ({ error }: { error: ResponseErrorDto }) => {
      toast.error(t(`API_ERRORS.${error.errorCode}`));
    },
  });

  return {
    handleGetFile,
    isLoading: isGettingFilePublicLink || isGettingFileFromBucket,
  };
};
